import React from "react";

interface TicketDetailsCellProps{
    title:string,
    value:string,
    classCSS:string
   }

   ///Questo componente mostra il dettaglio della cella del Ticket selezionato
   export const DetailsCell:React.FC<TicketDetailsCellProps> = ({title,value,classCSS}) =>{
    return(
        <div className={classCSS} >
            <label className="fw-bold">{title}</label><br/>
            <label className="readOnly plaintext">{value}</label>
        </div>
    );
   }